import React, { ReactEventHandler, useEffect, useRef, useState } from 'react'
import { AlertType, InputsRefs, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasVermelho } from '../../Utils/Types'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { UnidadeMedidaService } from '../../Pages/Unidades_Medida/UnidadeMedidaService'
import { FaSave } from 'react-icons/fa'
import { GiArchiveRegister } from 'react-icons/gi'

type Props = {

    setIdUnidMedida: (id: number) => void
    visible: boolean
    modalConfirmClick?: ReactEventHandler
    closeModal: () => void
}

export const ModalUniMedida = React.memo(({ setIdUnidMedida, visible, modalConfirmClick, closeModal }: Props) => {

    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")
    const [visibleMSG, setVisibleMSG] = useState(false)

    const [descUnid, setDescUnid] = useState("")
    const [fatorUnid, setFatorUnid] = useState("")
    const [idUnid, setIdUnid] = useState(0)

    useEffect(() => {

        if (visible) {

            let modal = document.getElementById('modal_unidMedida')
            let modalContent = document.getElementById('modal_content_unidMedida')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-400px]')
                    modalContent.classList.add('mt-24')
                }
            }

            const aguarde = setTimeout(() => {
                InputFocus()
                clearTimeout(aguarde)
            }, 200)


        } else {

            let modal = document.getElementById('modal_unidMedida')
            let modalContent = document.getElementById('modal_content_unidMedida')
            if (modal) {
                modal.style.visibility = 'hidden'


                if (modalContent) {
                    modalContent.classList.add('mt-[-400px]')
                    modalContent.classList.remove('mt-24')
                }
            }

            setDescUnid("")
            setFatorUnid("")
            setIdUnid(0)
            setVisibleMSG(false)
            setLoading(false)

        }

    }, [visible])

    const hadleChangeDesc = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescUnid(e.target.value)
    }

    const hadleChangeFator = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFatorUnid(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleCloseMessage = () => {
        setVisibleMSG(false)
    }

    const handleSaveUnidMedida = async (e: any) => {

        setVisibleMSG(false)

        try {

            let unidMedida: any = {
                description: descUnid,
                fator_conversao: parseFloat(fatorUnid),
                id: idUnid
            }

            setLoading(true)
            const resp = await UnidadeMedidaService.Save(unidMedida)
            //setLoading(false)

            InputFocus()

            if (resp.error) {

                setVisibleMSG(true)
                setMessage(resp.msg || "")
                setMessageType("DANGER")
                setLoading(false)

            } else {

                setVisibleMSG(true)
                setMessage("Dados salvos com sucesso")
                setMessageType("SUCCESS")

                setIdUnid(resp.id || 0)
                setIdUnidMedida(resp.id || -1)

                const aguarde = setTimeout(() => {
                    if (modalConfirmClick) {
                        modalConfirmClick(e)
                    }
                    clearTimeout(aguarde)
                }, 500)

            }

        } catch (error) {

            setVisibleMSG(true)
            setMessageType("DANGER")
            setMessage("Ocorreu um erro ao salvar a unidade de medida")
            setLoading(false)

        }
    }

    const InputFocus = () => {
        const input = document.getElementById('unidMedida')
        if (input) {
            input.focus()
        }
    }

    const handleKeyPressEnter = async (event: any) => {

        if ((event.code === "Enter" || event.code === "NumpadEnter") && visible) {

            event.preventDefault() // Evita o comportamento padrão do 'Enter'

            InputFocus()

        }
    }

    const inputsRefs: InputsRefs = {
        descUnidMed: useRef(null),
        fator: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && visible) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefs[keys[nextIndex]].current?.disabled || inputsRefs[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefs[keys[nextIndex]].current?.focus()

        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleKeyPressEnter)
        //document.addEventListener('keydown', handleTabPress)

        return () => {

            document.addEventListener('keydown', handleKeyPressEnter)
            //document.addEventListener('keydown', handleTabPress)
        }
    }, [visible])

    return (

        <div id="modal_unidMedida" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_unidMedida" className={`relative flex flex-col w-[90%] sm:w-[70%] md:w-[50%] lg:w-[40%] xl:w-[30%] 2xl:w-[25%] h-[280px] bg-white dark:bg-slate-600 rounded-lg mt-[-400px] transition-all duration-300 justify-center items-center  `}>

                <FeedbackMessage visible={visibleMSG} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <GiArchiveRegister className={`w-5 h-5 text-gray-800 dark:text-slate-100`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Cadastro - Unidades</span>

                </div>

                <div className={`absolute top-[70px] bottom-[60px] w-full h-full px-3 py-4`}>

                    <div className={`grid grid-cols-12 gap-4`}>

                        <div className={`relative col-span-12`}>
                            <input ref={inputsRefs.descUnidMed} onKeyDown={(e) => handleTabPress(e, 'descUnidMed')} id="unidMedida" className={`${classInput} ${classInputDark}`} type="text" inputMode='text' placeholder=" " autoComplete="off" value={descUnid} onChange={hadleChangeDesc} />
                            <label htmlFor="unidMedida" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Descrição</label>
                        </div>

                        <div className={`relative col-span-12`}>
                            <input ref={inputsRefs.fator} onKeyDown={(e) => handleTabPress(e, 'fator')} id="unidConversao" className={`${classInput} ${classInputDark} `} type="text" inputMode='numeric' placeholder=" " autoComplete="off" value={fatorUnid} onChange={hadleChangeFator} />
                            <label htmlFor="unidConversao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Conversão</label>
                        </div>
                    </div>

                </div>

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        tabIndex={-1}
                        disabled={loading}
                        onClick={closeModal}
                        className={`${loading ? 'opacity-40' : ''} ${classbtColunasVermelho} sm:max-w-[150px]`}>
                        CANCELAR
                    </button>

                    <button
                        tabIndex={-1}
                        disabled={loading}
                        onClick={handleSaveUnidMedida}
                        className={`${loading ? 'opacity-40' : ''} ${classbtAzul} ${classBt} sm:max-w-[150px]`}>
                        {!loading && <FaSave size={"18px"} className={`mr-2`} />}
                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {!loading ? `SALVAR` : "AGUARDE"}
                    </button>

                </div>

            </div>

        </div>

    )

})